import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './components/styles/ThemeContext';
import { InteriorViewer } from './components/Interior/InteriorViewer';
import { LevelsPage } from './pages/LevelsPage';
import { LayoutIconsPage } from './pages/LayoutIconsPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ThemeProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/levels" element={<LevelsPage data-id="element-4" />} data-id="element-3" />
          <Route path="/layout-icons" element={<LayoutIconsPage data-id="element-6" />} data-id="element-5" />
          <Route path="*" element={<InteriorViewer data-id="element-8" />} data-id="element-7" />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>;
}